import { useMutation } from 'react-query';

import { postV2ApiCompanyIdWalletFundTransfers } from 'src/client/spendesk-api';

import { type FundTransferBankInformationDetails } from '../types';

type CreateFundTransferPayload = {
  companyId: string;
  accountId: string;
  accountDetails: FundTransferBankInformationDetails;
  amount: {
    value: number;
    currency: 'EUR'; // only support EUR for the moment
  };
};

export const useCreateFundTransfer = () => {
  return useMutation(async (payload: CreateFundTransferPayload) => {
    const response = await postV2ApiCompanyIdWalletFundTransfers({
      path: {
        companyId: payload.companyId,
      },
      body: {
        amount: payload.amount,
        beneficiaryDetails: {
          ...payload.accountDetails,
          ...payload.accountDetails.details,
        },
      },
    });
    if (response.statusCode !== 202) {
      throw new Error('Failed to request wire funds out');
    }
    return response.body;
  });
};
